import {I18nSchema} from "./I18nSchema";

export const I18nEnglish: I18nSchema = {
    "WELCOME": "Welcome!",
    "LOGIN_FORM_TITLE": "Join The Community",
    "EMAIL": "E-Mail",
    "PASSWORD": "Password",
    "SIGN_IN": "Sign In",
    "SIGN_UP": "Sign Up",
    "SIGN_IN_NO_ACCOUNT": "No account?",
    "SIGN_IN_NO_ACCOUNT_CREATE_ONE": "Create one!",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "ALREADY_HAVE_ACCOUNT": "Already have an account?",
    "REQUIRED": "Required",
    "EMAIL_ERROR": "Email must be valid",
    "WRONG_CREDENTIALS": "The username or password is incorrect",
    "SUCCESSFUL_LOGIN": "Successful login",
    "SUCCESSFUL_SIGN_UP": "Account created successfully!",
    "BUILD_INTEGRATION": "Create integration",
    "START_INTEGRATION": "Start a N[C] integration",
    "LOGOUT": "Logout",
    "NAME": "Name",
    "HOME_PAGE": "Home page",
    "VERSION": "Version",
    "STATUS": "Status",
    "ACTIONS": "Actions",
    "INTEGRATIONS": "Integrations",
    "EMPTY_LIST": "Empty List",
    "MAIN_MENU": "Main Menu",
    "DESCRIPTION": "Description",
    "CANCEL": "Cancel",
    "CREATE": "Create",
    "DELETED": "Deleted",
    "WITH_GOOGLE": "with Google",
    "WITH_FACEBOOK": "with Facebook",
    "SIGNUP_WITH_EMAIL": "or sign up with email",
    "SIGNIN_WITH_EMAIL": "or sign in with email",
    "PRIVACY_POLICY_ALERT": "By signing up, you agree to Tact’s Terms of Service and Privacy Policy.",
    "PASSWORD_LENGTH": "password must be at least 6 characters",
    "AUTOMATE": "AUTOMATE",
    "YOUR": "YOUR",
    "TASKS": "tasks",
    "WITH_US": "WITH US",
    "DASHBOARD": "Dashboard",
    "APPLICATIONS": "Applications",
    "CHOOSE_APP_AND_EVENT": "Choose app & event",
    "CHOOSE_ACCOUNT": "Choose account",
    "SETUP_TRIGGER": "Setup trigger",
    "SETUP_ACTION": "Setup actions",
    "TEST_TRIGGER": "Test trigger",
    "TEST_ACTION": "Test actions",
    "NAME_YOUR_WORKFLOW": "Name Your workflow",
    "CREATE_WORKFLOW": "Create Workflow",
    "CONTINUE": "Continue",
    "EMPTY": "Empty",
    "WORKFLOW_TEST_TRIGGER_TITLE": "We will check that the correct account is connected and your trigger is configured correctly.",
    "UPDATE": "Update",
    "DISABLED": "Disabled",
    "ACTIVE": "Active",
    "CHANGE_APP": "Change app",
    "CURRENT_APP": "Current app",
    "CHOOSE_TRIGGER_EVENT": "Choose trigger event",
    "CHOOSE_ACTION_EVENT": "Choose actions event",
    "COPY_ACTION_ID": "Copy actions ID",
    "COPIED_TO_CLIPBOARD": "Copied to clipboard",
    "PLEASE_SAVE_CHANGES": "Please save changes",
    "SEARCH_HERE": "Search here",
    "WORKFLOW_WITH_NAME": "Workflow with name:",
    "WAS_NOT_FOUND": "was not found",
    "BUILD_INTEGRATION_TITLE": "Build a N[C] Integration",
    "BUILD_INTEGRATION_DESCRIPTION": "N[C]’s Free Developer Platform connects your API to the web’s top apps",
    "ARE_YOU_SURE": "Are you sure?",
    "REALLY_DELETE": "Do you really want to delete? This process cannot be undone",
    "WARNING": "Warning",
    "DELETE_INTEGRATION_WARNING": "By deleting this Integration all triggers and actions will also be deleted",
    "I_AGREE": "I agree",
    "WHAT_IS_API_KEY": "What is API Key Auth?",
    "WHAT_IS_SESSION_AUTH": "What is Session Auth?",
    "WHAT_IS_BASIC_AUTH": "What is Basic Auth?",
    "WHAT_IS_OAUTH2": "What is OAuth v2?",
    "WHAT_IS_API_KEY_ANSWER": "Use API Key authentication type if you simply need to collect some information from your users and then include that information, as it was entered by the user, when you make an API request. ",
    "WHAT_IS_SESSION_AUTH_ANSWER": "Use the session authentication type if you need to collect some information from your users, for example a user name and password, and then make a request to your API to exchange that information for a token or session key, wh...",
    "WHAT_IS_BASIC_AUTH_ANSWER": "Use the basic authentication type if your API relies on the HTTP “Basic” Authentication standard. When your user sets up a new Zap, Zapier will prompt them for a username and password, then automatically add the ...",
    "WHAT_IS_OAUTH2_ANSWER": "Oauth v2 authentication redirects users to your API’s site where they can authorize Zapier to access their account which sends a request token to Zapier that is exchanged for an access token.",
};
